import { createActionCreator } from '../../../utils/fsa';
import { IPopup } from '../reducers/popup';
import { IPopupStore } from '../reducers/store';
import { Dispatch } from 'redux';

export const openPopup = createActionCreator<IPopup>('popup/opened');

export const popupClosed = createActionCreator<{}>('popup/closed');

export const closePopup = <TApplicationState extends IPopupStore>() => {
  return (dispatch: Dispatch<TApplicationState>, getState: () => TApplicationState) => {
    const popup = getState().popup.openedPopups[0];

    if (popup) {
      if (popup.onClose) {
        popup.onClose(getState);
      }

      dispatch(popupClosed({}));
    }
  };
};



// WEBPACK FOOTER //
// ./src/bundles/popup/action_creators/popup.ts